module.exports = __webpack_public_path__ + "img/ljkt.31074225.gif";